import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { listPermissions, fetchPermission } from '../../services/permission'

function* handleFetchPermissions() {
  try {
    yield put({ type: actions.REQUESTING })
    const result = yield call(listPermissions)
    yield put({
      type: actions.FETCH_PERMISSIONS_RECEIVED,
      payload: result.data || result,
    })
  } catch (error) {
    console.error('Error fetching permissions:', error)
    yield put({
      type: actions.RESPONSE_ERROR,
      payload: error.message,
    })
    notification.error({
      message: 'Error',
      description: 'Failed to fetch permissions',
    })
  }
}

function* handleFetchPermission({ payload }) {
  try {
    yield put({ type: actions.REQUESTING })
    const result = yield call(fetchPermission, payload)
    yield put({
      type: actions.FETCH_PERMISSION_RECEIVED,
      payload: result.data || result,
    })
  } catch (error) {
    console.error('Error fetching permission:', error)
    yield put({
      type: actions.RESPONSE_ERROR,
      payload: error.message,
    })
    notification.error({
      message: 'Error',
      description: 'Failed to fetch permission',
    })
  }
}

function* watchPermissions() {
  yield all([
    takeEvery(actions.FETCH_PERMISSIONS, handleFetchPermissions),
    takeEvery(actions.FETCH_PERMISSION, handleFetchPermission),
  ])
}

export default watchPermissions
